const articleAction = () => {
  const selector = 'article_action';
  const components = new Component({
    component: document.querySelectorAll(`.${selector}`),
    callback: (cmpnt) => {
      const action = cmpnt.getAttribute('data-action');

      if (action) {
        new Element({
          type: 'div',
          classes: [
            `${selector}-action`,
          ],
          content: action,
          append: {
            parent: cmpnt,
          }
        })
      }
    },
  });
}

articleAction();